import { FileInfo } from "@/FileSystem/FileInfo";
import { convertFileInfosOpenBabel } from "@/FileSystem/OpenBabel/OpenBabel";
import { _convertTreeNodeListToPDB } from "./_ConvertTreeNodeListToPDB";
import { getFileNameParts } from "@/FileSystem/FilenameManipulation";
// function bondOrdersAssigned(treeNodes: TreeNode[]): boolean {
//     const bondOrders: Set<number> = new Set();
//     for (const treeNode of treeNodes) {
//         const atoms = getAtomsOfModel(treeNode.model as GLModel);
//         for (const atom of atoms) {
//             for (const bondOrder of atom.bondOrder) {
//                 bondOrders.add(bondOrder);
//             }
//         }
//     }
//     return !(bondOrders.size === 1 && bondOrders.has(1));
// }
/**
 * Given a list of mol containers, convert them to a specified molecular format.
 * Don't call this function directly. Instead, use TreeNodeList.toFileInfos().
 *
 * @param  {TreeNodeList}  treeNodeList  The list of mol containers.
 * @param  {string}        targetExt     The extension of the format to convert
 *                                       to.
 * @param  {boolean}      [merge]        Whether to merge the models into a
 *                                       single PDB string. Default is false.
 * @returns {FileInfo[]}  The text-formatted (e.g., PDB, MOL2) strings.
 */
export function _convertTreeNodeList(treeNodeList, targetExt, merge = true) {
    targetExt = targetExt.toLowerCase();
    // let calculateBondOrders = false;
    // if (formatInf.hasBondOrders === true) {
    //     // Sometimes a molecule might not have bond orders assigned, even if the
    //     // format supports it. In this case, use PDB as an intermediary because
    //     // they will force conversion via open babel, which will assign bond
    //     // orders for you.
    //     if (!bondOrdersAssigned(treeNodeList)) {
    //         calculateBondOrders = true;
    //     } else {
    //         // Use MOL2 as intermediary. First, convert the mol containers to a MOL2
    //         // string.
    //         molTxts = convertTreeNodeToMol2(treeNodeList, merge);
    //         intermediaryExt = "mol2";
    //         // If MOL2 is destination format, just return that
    //         if (formatInf.primaryExt === "mol2") {
    //             return Promise.resolve(molTxts);
    //         }
    //     }
    // }
    // if (formatInf.hasBondOrders !== true || calculateBondOrders) {
    // Get all the models from the tree nodes.
    const mols = treeNodeList.filters
        .keepModels()
        .map((treeNode) => treeNode.model);
    const allModelsAreIFileInfos = mols.every((mol) => {
        return mol.contents && mol.name;
    });
    let fileInfos = [];
    if (merge || !allModelsAreIFileInfos) {
        // If you need to merge the molecules, or if the models are not
        // IFileInfos, go through a PDB intermediate.
        // Use PDB as intermediary. First, convert the mol containers to a PDB
        // string.
        let molTxts = [];
        molTxts = _convertTreeNodeListToPDB(treeNodeList, merge);
        fileInfos = molTxts.map((molTxt, idx) => new FileInfo({
            name: `tmpmol${idx}.pdb`,
            contents: molTxt,
        }));
    }
    else {
        // Create new FileInfo objects from the frozen IFileInfo models
        // instead of mutating the originals (which may be Object.frozen).
        fileInfos = mols.map((mol, idx) => {
            const { ext } = getFileNameParts(mol.name);
            return new FileInfo({
                name: `tmpmol${idx}.${ext}`,
                contents: mol.contents,
            });
        });
    }
    return convertFileInfosOpenBabel(fileInfos, targetExt).then((contents) => {
        return contents.map((content) => {
            return new FileInfo({
                name: `tmpmol.${targetExt}`,
                contents: content,
            });
        });
    });
    // const promises = fileInfos.map((fileInfo: FileInfo) =>
    //     fileInfo.convertFromPDBTxt(targetExt)
    // );
    // return Promise.all(promises);
}
